export default __webpack_public_path__ + "static/media/Wristband of the Nebulous.31848be3.jpg";